<div class="main shadow">
    <div class="header" style="display: flex;">
        Facility Profile 
    <span *ngIf="queryParams.isDisable && showIcon" (click)="iconClicked()"  style="margin-left:auto; cursor:pointer;"><i class="fa fa-pencil-square-o" style="color:#ED1556 ;" aria-hidden="true"></i></span>
    </div>
    <!-- <div class="content"> -->
        <!-- <div class="contentText" *ngFor="let content of list; let index = index" (click)="handleList(content, index)"> -->
            <!-- [ngStyle]="{'background': clickedItem == content ? 'rgb(214, 214, 214)' : ''}"> -->
            <!-- {{content}} -->
             <!-- <span class="checkIcon"><i class="fa fa-check-circle" aria-hidden="true"></i></span> -->
        <!-- </div> -->
    <!-- </div> -->

    <ul class="content">
        <li class="contentText" *ngFor="let content of list; let index = index" (click)="handleList(content, index)">
            <!-- [ngStyle]="{'background': clickedItem == content ? 'rgb(214, 214, 214)' : ''}"> -->
            {{content}}
             <!-- <span class="checkIcon"><i class="fa fa-check-circle" aria-hidden="true"></i></span> -->
        </li>
    </ul>
</div>